import { categories, seriesList } from '@/mocks/manhwa';

interface HotSeriesProps {
  search: string;
  category: string;
  onCategoryChange: (c: string) => void;
}

export default function HotSeries({ search, category, onCategoryChange }: HotSeriesProps) {
  const filtered = seriesList.filter((s) => {
    const matchCat = category === '全部' || s.category === category;
    const kw = search.trim().toLowerCase();
    const matchSearch = !kw || s.title.toLowerCase().includes(kw) || s.desc.toLowerCase().includes(kw);
    return matchCat && matchSearch;
  });

  return (
    <section id="hot" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">热门连载推荐</h2>
            <p className="mt-2 text-sm text-foreground-600">高人气韩漫抢先看，点击分类即可快速筛选你感兴趣的题材。</p>
          </div>
        </div>

        <div className="mb-8 flex flex-wrap items-center gap-2">
          {['全部', ...categories.map((c) => c.name)].map((c) => (
            <button
              key={c}
              onClick={() => onCategoryChange(c)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                category === c
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="rounded-lg bg-background-50 py-16 text-center">
            <i className="ri-search-line text-3xl text-foreground-300" />
            <p className="mt-3 text-sm text-foreground-600">没有找到匹配的连载，换个关键词或分类试试吧。</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {filtered.map((s) => (
              <article
                key={s.id}
                className="group flex gap-4 overflow-hidden rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-50"
              >
                <div className="relative h-[180px] w-[128px] shrink-0 overflow-hidden rounded-md">
                  <img
                    src={s.cover}
                    alt={`${s.title} ${s.category}韩漫连载封面`}
                    title={`${s.title} 漫画韩国下拉式熟肉`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-1.5 top-1.5 rounded bg-black/55 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
                    {s.category}
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 flex-col py-1">
                  <h3 className="truncate font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-fill text-primary-500" />
                    热度 {s.heat}
                    <span className="mx-1 text-background-300">·</span>
                    <i className="ri-star-fill text-accent-500" />
                    {s.rating}
                  </p>
                  <p className="mt-1 text-xs text-secondary-700">{s.chapters}</p>
                  <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">{s.desc}</p>
                  <div className="mt-auto flex items-center gap-2 pt-3">
                    <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">{s.group}</span>
                    <button className="ml-auto rounded-md bg-primary-50 px-3 py-1 text-xs font-bold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                      开始阅读
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}